import { throttle } from 'throttle-debounce';
import { KEY_ESCAPE } from 'keycode-js';
import $ from '../lib/jquery';

import { Component } from '../core/component';

export class NavigationDropdowns extends Component {
    selector = '.js-nav-item';

    $dropdowns = [];

    $nav = [];

    animationLength = 250;

    hasDropdownOpen = false;

    init() {
        this.$dropdowns = $('.js-nav-dropdown');
        this.$nav = $('.js-nav');

        this.$elements.on('click', (evt) => {
            evt.stopPropagation();
            this.openDropdown($(evt.currentTarget));
        });

        $(document).on('click', () => {
            this.closeDropdowns();
        });

        this.$dropdowns.on('click', (evt) => {
            evt.stopPropagation();
        });

        $(document).on('keyup', (evt) => {
            if (evt.keyCode === KEY_ESCAPE) {
                this.closeDropdowns();
            }
        });

        $(window).on('scroll', this.onScroll);
    }

    async openDropdown($trigger) {
        const isCurrentOpen = $trigger.hasClass('is-active');

        await this.closeDropdowns();

        // if dropdown was already open, we don't want to reopen it
        // The users's intent by clicking on the one that was
        // already open is to close it
        if (isCurrentOpen) return;

        const $dropdown = $(`#${$trigger.data('dropdown-id')}`);

        this.hasDropdownOpen = true;

        this.$nav.addClass('is-open');
        $trigger.addClass('is-active');
        $trigger.attr('aria-expanded', 'true');
        $dropdown.addClass('is-active is-visible');
    }

    closeDropdowns() {
        return new Promise((resolve) => {
            this.$elements.removeClass('is-active');
            this.$elements.attr('aria-expanded', 'false');
            this.$nav.removeClass('is-open');

            const $activeDropdowns = this.$dropdowns;

            $activeDropdowns.filter('.is-active');

            if (!this.hasDropdownOpen) {
                return resolve();
            }

            $activeDropdowns.removeClass('is-active');

            setTimeout(() => {
                this.$dropdowns.removeClass('is-visible');
                this.hasDropdownOpen = false;
                resolve();
            }, this.animationLength);
        });
    }

    onScroll = throttle(100, () => {
        if (this.hasDropdownOpen) {
            this.closeDropdowns();
        }
    });
}



// WEBPACK FOOTER //
// ./assets/js/components/NavigationDropdowns.js